import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { EnviarRecibosDef } from "./EnviarRecibosDef";

export const EnviarRecibosHelpText = "* Enviar recibos.";
export const EnviarRecibosIcon = IconBuildingCommunity;

export class EnviarRecibos extends Entity<EnviarRecibosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new EnviarRecibosDef(), parentKeys);
        this.Form = import('./EnviarRecibosForm').then((module) => module.EnviarRecibosForm);
        this.Title = "Proceso de Envío de Recibos de Sueldo";
        this.HelpText = EnviarRecibosHelpText;
        this.Icon = EnviarRecibosIcon;
    }
}